;(function (angular, $, window) {
    'use strict';
    angular.module('digitickApp').controller('BlockHeaderShoppingCartCtrl', ['$scope', '$rootScope', 'ShoppingCartFactory', 'AuthService', function($scope, $rootScope, ShoppingCartFactory, AuthService) {
        $rootScope.headerBigShow = false;
        $rootScope.headerTinyHeight = 0;

        $scope.AuthService = AuthService;

        $scope.ShoppingCartFactory = ShoppingCartFactory;

        $rootScope.headerTinyHeight = angular.element('.header-shopping-cart').height();

        $('#wrapper, [side-panel]').css('margin-top', $rootScope.headerTinyHeight + 'px');

        $('.icone-service-client-2016[data-toggle="popover"]').popover();

    }]);
})(angular, jQuery, window);